import { Box, Typography } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Box
      sx={{
        mt: 4,
        py: 2,
        textAlign: "center",
        backgroundColor: "#f2f2f2",
      }}
    >
      <Typography
        variant="body1"
        sx={{ fontWeight: 500, letterSpacing: 1.2, color: "#666" }}
      >
        MADE BY KEDAR
        <a
          href="https://kedar355.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            marginLeft: "8px",
            textDecoration: "underline",
          }}
        >
          Portfolio
        </a>
      </Typography>
    </Box>
  );
};

export default Footer;
